



import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { PostSiteEventMarkerCollection, PostSiteEventMarkerCollectionResponse } from "../../api/dtos/dtos";
import usePost from "../api/usePost";

const getData = (response?: SWRResponse<PostSiteEventMarkerCollectionResponse, PostSiteEventMarkerCollectionResponse>) => response?.data;
const getError = (response?: SWRResponse<PostSiteEventMarkerCollectionResponse, PostSiteEventMarkerCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<PostSiteEventMarkerCollectionResponse, PostSiteEventMarkerCollectionResponse>) => ({});

const usePostSiteEventMarkerCollection = (query?: Partial<PostSiteEventMarkerCollection>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new PostSiteEventMarkerCollection(query);
        }
    }, [query]);

    return usePost(request, { getData, getError, getAdditionalState }, configuration);
}

export default usePostSiteEventMarkerCollection;